module.exports = __webpack_public_path__ + "img/2.3f6b7a49.png";